import {createContext, memo, useContext} from 'react'

import useTrackingActiveAreaProvider from './TrackingActiveAreaContext.hooks'
import type {
  TrackingActiveAreaContextProps,
  TrackingActiveAreaProviderProps,
} from './TrackingActiveAreaContext.types'

const TrackingActiveAreaContext = createContext<TrackingActiveAreaContextProps>({
  isActiveArea: false,
})

function TrackingActiveAreaProvider({children}: TrackingActiveAreaProviderProps) {
  const {handlerParentFocusBlur, handlerParentMouseEnterLeave, value} =
    useTrackingActiveAreaProvider()

  return (
    <TrackingActiveAreaContext.Provider value={value}>
      <div
        onFocus={handlerParentFocusBlur}
        onBlur={handlerParentFocusBlur}
        onMouseEnter={handlerParentMouseEnterLeave}
        onMouseLeave={handlerParentMouseEnterLeave}
      >
        {children}
      </div>
    </TrackingActiveAreaContext.Provider>
  )
}

export default memo<TrackingActiveAreaProviderProps>(TrackingActiveAreaProvider)

export const useTrackingActiveArea = (): TrackingActiveAreaContextProps =>
  useContext(TrackingActiveAreaContext)
